// extracted by mini-css-extract-plugin
module.exports = {"badge":"column-support-meeting-activities_badge__228LH"};